import * as React from "react";
import * as ReactDOM from "react-dom";
import { BookingEngine } from "./index";
import HotelIntegration from "../components/BookingEngineIntegration/HotelIntegration";
import { AuthProvider } from "../components/BookingEngineIntegration/AuthContext";
import { honeybadger } from "../settings/IntegrationConstants";
import ErrorBoundary from "@honeybadger-io/react";

declare global {
  interface Window {
    gb_data: any;
  }
}

honeybadger.beforeNotify(function(notice) {
  console.log('%c Honeybadger Notify (hotelIntegrationHandlers): ' + notice.stack, 'background: #fffcf2; color: #E65840');
  if (/integrations.theguestbook.com|gstbk.com|theguestbook.com/.test(notice.stack) == false) { return false; }
  if (/static.hooray.agency/.test(notice.stack)) { return false; }
});

const TurboDisabler = ({ children }) => {
  React.useEffect(() => {
    const elements = document.querySelectorAll('a, button, input');
    elements.forEach(el => el.setAttribute('data-turbo', 'false'));
  }, []);
  return <>{children}</>;
};

export const handleIntegrationInjector = (hotelClass: BookingEngine) => {
  if (document.querySelectorAll("#gb_widget_app").length === 0) {
    let widgetContainer = document.createElement("div");
    widgetContainer.setAttribute("id", "gb_widget_app");
    const targetToAppend = document.querySelector("body");
    if (targetToAppend) {
      targetToAppend.appendChild(widgetContainer);
    }
    let container = document.getElementById("gb_widget_app");
    const gbData = window.gb_data;
    ReactDOM.render(
      <ErrorBoundary honeybadger={honeybadger}>
        <AuthProvider>
          <TurboDisabler>
            <HotelIntegration bookingEngine={hotelClass} hotelSettings={gbData} />
          </TurboDisabler>
        </AuthProvider>
      </ErrorBoundary>,
      container
    );
  }
};
